// Update Swiper JS for Layout Banner Slider
document.addEventListener("DOMContentLoaded", () => {
	AOS.init({
		once: true,
	});

	new Swiper(".logo-swiper", {
		slidesPerView: 6,
		spaceBetween: 20,
		loop: true,
		speed: 1000,
		autoplay: {
			delay: 0,
		},
		allowTouchMove: false,
		breakpoints: {
			1920: {
				slidesPerView: 6,
				spaceBetween: 20,
				pagination: false,
			},
			1199: {
				slidesPerView: 6,
				spaceBetween: 30,
				pagination: false,
			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 30,
				pagination: false,
			},
			834: {
				slidesPerView: 4,
				spaceBetween: 5,
				pagination: false,
			},
			767: {
				slidesPerView: 4,
				spaceBetween: 4,
				pagination: false,
			},
			650: {
				slidesPerView: 3,
				spaceBetween: 4,
				pagination: false,
			},
			480: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			200: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
		},
	});

	new Swiper("#default-carousel", {
		loop: true,
		autoplay: {
			delay: 4000,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

	new Swiper(".compliance-slider", {
		loop: true,
		slidesPerView: 3,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			1024: {
				slidesPerView: 3,
				spaceBetween: 50,
				pagination: false,
			},
			640: {
				slidesPerView: 2,
				spaceBetween: 40,
			},
			480: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			320: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
		},
	});
});

// Custom JS 2/07/2025 ===
document.addEventListener("DOMContentLoaded", function () {
	// Open modal and play video
	function openVideoModal(videoUrl, videoType) {
		var modal = document.getElementById("videoModal");
		var video = document.getElementById("modalVideo");
		var modalYoutube = document.getElementById("modalYoutube");
		console.log(videoType);
		if (videoType == "V") {
			if (video) {
				video.classList.remove("hidden");
				video.src = videoUrl;
				video.currentTime = 0;
				video.play();
			}
		} else {
			if (modalYoutube) {
				modalYoutube.classList.remove("hidden");
				// Ensure autoplay for YouTube embed
				if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
					// Add autoplay=1 and enable ADA-friendly features
					let url = new URL(videoUrl, window.location.origin);
					if (!url.searchParams.has("autoplay"))
						url.searchParams.set("autoplay", "1");
					url.searchParams.set("rel", "0");
					url.searchParams.set("modestbranding", "1");
					url.searchParams.set("playsinline", "1");
					url.searchParams.set("enablejsapi", "1");
					modalYoutube.src = url.toString();
				} else {
					modalYoutube.src = videoUrl;
				}
			}
		}
		modal.classList.remove("hidden");
		modal.classList.add("flex");
		// Trap focus for accessibility
		setTimeout(function () {
			modal.querySelector(".close-button").focus();
		}, 100);
	}

	// Close modal and stop video
	function closeVideoModal() {
		var modal = document.getElementById("videoModal");
		var video = document.getElementById("modalVideo");
		var modalYoutube = document.getElementById("modalYoutube");
		if (video) {
			video.pause();
			video.src = "";
		}
		if (modalYoutube) {
			modalYoutube.src = "";
		}
		modal.classList.remove("flex");
		modal.classList.add("hidden");
		modalYoutube.classList.add("hidden");
		video.classList.add("hidden");
	}

	// Attach click and keyboard event to play buttons
	document.querySelectorAll(".play-button-vdo").forEach(function (btn) {
		btn.addEventListener("click", function (e) {
			var videoUrl = btn.getAttribute("data-video");
			var videoType = btn.getAttribute("data-type");
			if (videoType == null) {
				videoType = "V";
			}
			if (videoUrl) {
				openVideoModal(videoUrl, videoType);
			}
		});
		btn.addEventListener("keydown", function (e) {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault();
				var videoUrl = btn.getAttribute("data-video");
				var videoType = btn.getAttribute("data-type");
				if (videoType == null) {
					videoType = "V";
				}
				if (videoUrl) {
					openVideoModal(videoUrl, videoType);
				}
			}
		});
	});

	document
		.getElementById("closeVideoModal")
		.addEventListener("click", function () {
			closeVideoModal();
		});

	// Close modal on ESC key
	document.addEventListener("keydown", function (e) {
		var modal = document.getElementById("videoModal");
		if (
			!modal.classList.contains("hidden") &&
			(e.key === "Escape" || e.key === "Esc")
		) {
			closeVideoModal();
		}
	});

	// Optional: Close modal when clicking outside the video container
	document.getElementById("videoModal").addEventListener("click", function (e) {
		if (e.target === this) {
			closeVideoModal();
		}
	});

	// Expose closeVideoModal globally for backward compatibility
	window.closeVideoModal = closeVideoModal;
});

document.addEventListener("DOMContentLoaded", function () {
	const video = document.getElementById("videoBanner");
	const speakerBtn = document.getElementById("videoSpeakerBtn");
	const volumeSlider = document.getElementById("videoVolume");
	const soundWave1 = document.getElementById("soundWave1");
	const soundWave2 = document.getElementById("soundWave2");
	const soundWave3 = document.getElementById("soundWave3");
	const muteLine = document.getElementById("muteLine");
	const muteLine2 = document.getElementById("muteLine2");

	// Helper to update SVG for mute/unmute
	function updateSpeakerIcon(muted) {
		if (soundWave1 && soundWave2 && soundWave3 && muteLine && muteLine2) {
			if (muted) {
				soundWave1.style.opacity = 0;
				soundWave2.style.opacity = 0;
				soundWave3.style.opacity = 0;
				muteLine.classList.remove("hidden");
				muteLine2.classList.remove("hidden");
			} else {
				soundWave1.style.opacity = 0.3;
				soundWave2.style.opacity = 0.5;
				soundWave3.style.opacity = 0.7;
				muteLine.classList.add("hidden");
				muteLine2.classList.add("hidden");
			}
		}
	}

	// Set initial state: muted
	if (video) {
		video.muted = true;
		video.volume = 0;
	}
	if (volumeSlider) {
		volumeSlider.value = 0;
		volumeSlider.setAttribute("aria-valuenow", 0);
	}
	updateSpeakerIcon(true);

	// Toggle mute/unmute on speaker button click
	if (speakerBtn && video) {
		speakerBtn.addEventListener("click", function () {
			video.muted = !video.muted;
			if (video.muted) {
				speakerBtn.setAttribute("aria-label", "Unmute video");
				speakerBtn.setAttribute("aria-pressed", "false");
				if (volumeSlider) {
					volumeSlider.value = 0;
					video.volume = 0;
					volumeSlider.setAttribute("aria-valuenow", 0);
				}
				updateSpeakerIcon(true);
			} else {
				speakerBtn.setAttribute("aria-label", "Mute video");
				speakerBtn.setAttribute("aria-pressed", "true");
				// Set to a default volume if unmuted and volume is 0
				if (video.volume === 0) {
					video.volume = 0.5;
					if (volumeSlider) {
						volumeSlider.value = 0.5;
						volumeSlider.setAttribute("aria-valuenow", 0.5);
					}
				}
				updateSpeakerIcon(false);
			}
		});
	}

	// Volume slider control
	if (volumeSlider && video) {
		volumeSlider.addEventListener("input", function () {
			const vol = parseFloat(this.value);
			video.volume = vol;
			video.muted = vol === 0;
			volumeSlider.setAttribute("aria-valuenow", vol);
			updateSpeakerIcon(video.muted);
			if (speakerBtn) {
				if (video.muted) {
					speakerBtn.setAttribute("aria-label", "Unmute video");
					speakerBtn.setAttribute("aria-pressed", "false");
				} else {
					speakerBtn.setAttribute("aria-label", "Mute video");
					speakerBtn.setAttribute("aria-pressed", "true");
				}
			}
		});
	}
});

// Custom JS 13/11/2025 HubSpot Modal ===
function logButtonTitle(title) {
	var modalHeading = document.getElementById("modal-heading-global");
	if (title) {
		modalHeading.textContent = title;
	}
}

document.addEventListener("DOMContentLoaded", function () {
	document
		.querySelectorAll('[data-x-on-click="hubspotModalOpen = true"]')
		.forEach(function (btn) {
			btn.addEventListener("click", function (e) {
				var title = btn.getAttribute("data-title") || "";
				logButtonTitle(title);
			});
		});
});
